
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FooterComponent } from '../../footer/footer.component';
import { FooterSimpleComponent } from '../../footer/footer-simple/footer-simple.component';
import { IContent } from '../../../models/content.model';

@Component({
    selector: 'butterfly-footer-wrapper',
    templateUrl: './footer-wrapper.component.html',
    imports: [FooterComponent, FooterSimpleComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterWrapperComponent {
    @Input({ required: true }) config!: IContent;
    @Input() culture?: string;
}
